module.exports = __webpack_public_path__ + "img/singapore.81f2bae6.svg";